import { Faq } from "pages";
import routesMap from "routeControl/userRouteMap";

export default function route() {
  return [
    {
      path: routesMap.FAQ.path,
      name: "Faq",
      key: routesMap.FAQ.path,
      // commonRoute: false,
      private: true,
      // withAuth: true,
      // belongsToHeader: true,
      element: <Faq />,
    }
  ];
}
